module.exports = __webpack_public_path__ + "static/img/装饰13.b28fe2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰13.svg
// module id = A1pp
// module chunks = 2